import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Список SPA маршрутов, для которых 404 ошибки можно игнорировать
const SPA_ROUTES = [
  '/profile',
  '/simulator',
  '/sandbox',
  '/login',
  '/courses',
  '/faq',
  '/docs',
  '/telegram-auth',
  '/task/'
];

// Перехватываем ошибки консоли для скрытия 404 от SPA маршрутов
const originalError = console.error;
console.error = (...args) => {
  const message = args.join(' ');
  // Пропускаем ошибки 404 для известных SPA маршрутов
  if (message.includes('404') && SPA_ROUTES.some(route => message.includes(route))) {
    return; // Не выводим ошибку в консоль
  }
  originalError.apply(console, args);
};


ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);